import React from "react"
import { Grid, Button } from "semantic-ui-react"

const AskTemplate = ({
  heading,
  description,
  onYesButtonProps,
  onNoButtonProps
}) => (
  <Grid centered container style={{ paddingTop: "4em", paddingBottom: "8em" }}>
    <Grid.Row style={{ paddingBottom: "0" }}>
      <Grid.Column
        textAlign="center"
        style={{ fontSize: "2.5em", fontWeight: "300" }}
      >
        <p>{heading}</p>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row centered style={{ paddingTop: "0" }}>
      <Grid.Column textAlign="center">
        <p
          className="greyed-text"
          style={{
            fontSize: "1.5em",
            fontWeight: "300",
            maxWidth: "30em",
            textAlign: "center",
            marginLeft: "auto",
            marginRight: "auto"
          }}
        >
          {description}
        </p>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row columns="2" style={{ paddingTop: "4em", paddingBottom: "3em" }}>
      <Grid.Column textAlign="right">
        <Button {...onNoButtonProps} />
      </Grid.Column>
      <Grid.Column>
        <Button {...onYesButtonProps} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

const AskPlan = ({ onYes, onNo }) => (
  <AskTemplate
    heading="Does your employer provide a retirement plan?"
    description={` Employer-sponsored retirement plans come by many names, but the
most common are 401(k), 403(b), 457(b).`}
    onNoButtonProps={{
      "data-testid": "no",
      onClick: onNo,
      basic: true,
      content: "No",
      type: "button",
      primary: true
    }}
    onYesButtonProps={{
      "data-testid": "yes",
      primary: true,
      content: "Yes",
      type: "button",
      onClick: onYes
    }}
  />
)

// const ConfirmRetirement = ({ onYes, onNo }) => (
//   <AskTemplate
//     heading="Are you sure?"
//     description={`You must add a retirement plan benefit to
//   associate the retirement account you've already entered with a current employer.
//   Is the retirement account you previously entered for a current or prior employer?`}
//     onNoButtonProps={{
//       "data-testid": "priorEmployer",
//       onClick: onNo,
//       content: "Prior Employer",
//       type: "button",
//       primary: true
//     }}
//     onYesButtonProps={{
//       "data-testid": "currentEmployer",
//       primary: true,
//       content: "Current Employer",
//       type: "button",
//       onClick: onYes
//     }}
//   />
// )

export class AskRetirementPlan extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      succeeded: false,
      cancelled: false
    }
  }
  onSuccess = () => {
    this.setState({ succeeded: true })
  }
  onCancel = async () => {
    const {
      updateHousehold,
      household: { id }
    } = this.props
    await updateHousehold({ id, has_confirmed_benefits: true })
    this.setState({ cancelled: true })
  }
  render = () => {
    if (this.state.cancelled) {
      return this.props.onCancel()
    }
    if (this.state.succeeded) {
      return this.props.onSuccess()
    }
    // if (this.state.confirm) {
    //   const { accounts } = this.props
    //   if (
    //     accounts.some(
    //       ({ type }) =>
    //         type === "401k" ||
    //         type === "403b" ||
    //         type === "457b" ||
    //         type === "roth_401k" ||
    //         type === "roth_403b" ||
    //         type === "roth_457b"
    //     )
    //   ) {
    //     return <ConfirmRetirement onYes={this.onSuccess} onNo={this.onCancel} />
    //   }
    //   return this.props.onCancel()
    // }
    return (
      <AskPlan
        onYes={this.onSuccess}
        onNo={() => {
          const { accounts } = this.props
          if (
            accounts.some(
              ({ type }) =>
                type === "401k" ||
                type === "403b" ||
                type === "457b" ||
                type === "roth_401k" ||
                type === "roth_403b" ||
                type === "roth_457b"
            )
          ) {
            // this.setState({ confirm: true })
            this.onCancel()
          } else {
            this.onCancel()
          }
        }}
      />
    )
  }
}
